import { lazy } from 'react';
import { Outlet } from 'react-router-dom';

import LoggedOutLayout from 'components/layout/LoggedOutLayout';
import Loadable from 'components/ui/Loadable';
import GuestGuard from 'utils/routeGuard/GuestGuard';

const LoginPage = Loadable(lazy(() => import('components/pages/LoginPage')));
const RegisterPage = Loadable(
  lazy(() => import('components/pages/RegisterPage'))
);
const ForgotPassword = Loadable(
  lazy(() => import('components/pages/ForgotPassword'))
);
const RegisterActivation = Loadable(
  lazy(() => import('components/pages/RegisterActivation'))
);
const PasswordActivation = Loadable(
  lazy(() => import('components/pages/PasswordActivation'))
);
const CodeVerification = Loadable(
  lazy(() => import('components/pages/CodeVerification'))
);
const WelcomeEmail = Loadable(
  lazy(() => import('components/pages/WelcomeEmail'))
);
const ChangePassword = Loadable(
  lazy(() => import('components/pages/ChangePasswordPage'))
);
const TermsAndConditionsPage = Loadable(
  lazy(() => import('components/pages/TermsAndConditions'))
);

const LoggedOutRoutes = {
  path: '',
  element: (
    <GuestGuard>
      <Outlet />
    </GuestGuard>
  ),
  children: [
    {
      path: '/login',
      element: <LoginPage />,
    },
    {
      path: '/register',
      element: <RegisterPage />,
    },
    {
      path: '/forgot-password',
      element: <ForgotPassword />,
    },
    {
      path: '/register-activation',
      element: <RegisterActivation />,
    },
    {
      path: '/password-activation',
      element: <PasswordActivation />,
    },
    {
      path: '/code-verify',
      element: <CodeVerification />,
    },
    {
      path: '/welcome-email',
      element: <WelcomeEmail />,
    },
    {
      path: '/change-password',
      element: <ChangePassword />,
    },
    {
      path: '/terms-and-conditions-out',
      element: (
        <LoggedOutLayout fullWidth>
          <TermsAndConditionsPage />
        </LoggedOutLayout>
      ),
    },
  ],
};

export default LoggedOutRoutes;
